import { styled, MenuItem, MenuItemProps } from "@mui/material";

interface IDropdownMenuItemProps extends MenuItemProps {
  secondary?: boolean;
}

export const StyledDropdownMenuItem = styled(MenuItem)<IDropdownMenuItemProps>`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.wsc.spacing[1]};
  background-color: transparent;
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  padding: ${(props) => props.theme.wsc.spacing[1]}
    ${(props) => props.theme.wsc.spacing[2]};

  &:hover,
  &.Mui-selected:hover {
    background-color: rgba(
      51,
      51,
      51,
      1
    ); // TOOO - convert to new palette color Neutral/600 Hover
    ${(props) =>
      props.secondary &&
      `
            color: rgba(241, 255, 108, 1); // TOOO - convert to new palette color Primary/100 hover
        `}
  }
  &.MuiMenuItem-root {
    && {
      min-height: auto;
    }
    white-space: normal;
    &.Mui-selected {
      background-color: rgba(
        64,
        64,
        64,
        1
      ); // TOOO - convert to new palette color Neutral/500 selected
      font-weight: ${(props) =>
        props.theme.wsc.typography.body1bold.fontWeight};
      ${(props) =>
        props.secondary &&
        `
              color: rgba(241, 255, 108, 1); // TOOO - convert to new palette color Primary/100 hover
          `}
    }

    &.Mui-disabled {
      background-color: transparent;
      &:hover {
        background-color: rgba(
          93,
          93,
          93,
          1
        ); // TOOO - convert to new palette color Neutral/400 disable text
      }
    }
  }

  .DropdownItemLabel {
    flex: 1;
    max-width: 100%;
  }
`;
